<template>
  <form @submit.prevent>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $utils.upperFirst(bulkAction) }} Proposals</p>
      </header>
      <section class="modal-card-body">
        <div class="pb-md-border-b">
          <div class="columns is-vcentered">
            <div class="column">
              <p>Do you want to {{ $utils.upperFirst(bulkAction) }} selected proposals?</p>
            </div>
            <div class="column is-narrow">
              <b-button
                type="is-primary rounded-lg"
                @click="performAction"
                :loading="processing"
                :disabled="processing"
              >{{ $utils.upperFirst(bulkAction) }} Selected Proposals</b-button>
            </div>
          </div>
        </div>
        <!-- Results -->
         <div>
          <b-table
            :data="proposals"
            :mobile-cards="false"
            hoverable
            class="is-size-7">
            <template>
              <!-- Label -->
              <b-table-column
                label="ID"
                header-class="nowrap"
                cell-class="nowrap"
                width="64"
                v-slot="props">
                {{ props.row.id }}
              </b-table-column>
              <b-table-column
                label="Name"
                header-class="nowrap"
                cell-class="nowrap"
                width="128"
                v-slot="props">
                {{ props.row.name }}
              </b-table-column>
            </template>
          </b-table>
         </div>
      </section>
      <footer class="modal-card-foot space-between">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <button class="button" type="button" @click="closeAndReload()">Close & Reload</button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      processing: false,
      found: null,
      successs: null,
      failed: null,
      errors: null
    }
  },
  computed: {
    ...mapGetters(['context']),
    endpoint () {
      return `${this.context.route}/proposals/bulk-${this.bulkAction}/`
    },
    json () {
      const json = {
        proposal_ids: this.proposals.map(proposal => proposal.id)
      }
      return json
    }
  },
  methods: {
    performAction () {
      this.processing = true
      this.$http.post(this.endpoint, this.json).then(response => {
        this.$buefy.toast.open({ type: 'is-success', message: `Proposals ${this.bulkAction === 'approve' ? 'Approved' : 'Rejected'}` })
        this.found = response.data.total_found
        this.successs = response.data.total_success
        this.failed = response.data.total_failure
        this.errors = response.data.errors
        this.closeAndReload()
      }).catch(error => {
        this.$buefy.toast.open({ type: 'is-danger', message: 'An error occurred! Please check your input and try again!' })
        this.errors = (error.response.data) ? error.response.data : { detail: 'An unexpected error occured!' }
      }).finally(() => {
        this.processing = false
      })
    },
    closeAndReload () {
      this.$emit('reload')
      this.$parent.close()
    }
  },
  props: {
    proposals: {
      type: Array,
      required: true
    },
    bulkAction: {
      type: String,
      required: true
    }
  }
}
</script>
